// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2_qJG","bigColWidth":"Table_bigColWidth__2Cs39","biggerColWidth":"Table_biggerColWidth__WIyGd","row":"Table_row__vUBlX","col":"Table_col__386pX"};